import * as types from '../actions/_actionTypes';
import initialState from './_initialReducerState'

export default function BudgetlineReducer(state = initialState.budgetline, action: any) {
  switch (action.type) {
    case types.SAVE_BUDGETLINE_SUCCESS:
      return action.budgetline;
    default:
      return state;
  }
}
